export class PartnerCategory {
	public CategoryCode: string;
	public CategoryName: string;
	constructor() {
		this.CategoryName ='';
	}
}
